<template>
<!-- FINAL ICARE -->

<div class="wrapper">
  <div>
      <CRow class="mt-3">
        <div>       
        </div>
      <CCol sm="12">
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-body">
                        <Datatable 
                            :items="items" 
                            :fields="fields" 
                            :meta="meta" 
                            @per_page="handlePerPage" 
                            @pagination="handlePagination" 
                            @search="handleSearch" 
                            @sort="handleSort"
                            @is_active="handleIsActive"
                            :btn_show="true"
                            :btn_edit="true"
                            :btn_deactivate="true"
                            :btn_reactivate="false"
                            :btn_delete="false"
                            @showEvent="handleShowEvent"
                            @editEvent="handleEditEvent"
                            @changeToPublish="handlechangeToPublish"
                            @showRegistrationPage="handleShowRegistrationPage"
                            @deactivate="handleDeactivate"
                            @reactivate="handleReactivate"
                        />
                    </div>
                </div>
            </div>
        </div>  
      </CCol>
    </CRow>

    <alertmodal></alertmodal>
</div>
</div>
</template>

<script>
import Datatable from '@/components/datatables_event_order.vue'
import axios from 'axios';

import event from '@/services/event';

import alertmodal from '@/views/alert/modal.vue';
import EventBus from '@/eventBus';
import store from '@/store.js'



const token = localStorage.getItem('token');

export default {
  name: 'IcareTables',
  components: { Datatable, alertmodal },
   data () {
    return {
      events: [],
      largeModal: false,
      updateSubmit: false,
      fields: [
          {key: 'name', sortable: false, },
          {key: 'email', sortable: false, },
          {key: 'payment_status', sortable: false, },
          {key: 'action', sortable: false, },
      ],
      items: [],
      meta: [],
      current_page: 1,
      per_page: 10,
      search: '',
      sortBy: 'name',
      sortByDesc: false,
      is_active: 1,
    }
   },
   mounted (){
     this.loadData()
      EventBus.$on('TABLE_UPDATE', (data) => {
      if(data){
          this.loadData();
      }
    });
   },

  methods: {
     openNew: function () {
      this.$router.push({name:'Event Form'}) 
    },
    
    openShowEvent: function(id) {
      
     this.$router.push({name:'Event Detail',query: {id:id} }) 
        console.log(' open show detail')
     
      //SET END  
        },

    // openShowRegistration: function(registration_link) {
      
    //  this.$router.push({name:'Registration Form',query: {registration_link:registration_link} }) 
    //     console.log(' open show detail')
     
    //   //SET END  
    //     },

    openEditEvent(id){
      this.$router.push({name:'Event Form',query: {id:id} })      
    },
    changeToPublish(id){
    
      if(confirm("Do you really want to publish this event?")){
        event.publishEvent(id)
        .then(res => {
          EventBus.$emit('TABLE_UPDATE', true)
          var params = {title: 'Success', mode:'success', data:res.message}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
        }).catch ((err) => {
          var params = {title: 'Error', mode:'danger', data:err.response.data.message}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
        })
      }  
    
    },
    showRegistrationPage(id){
      let route = this.$router.resolve(
        {
        path: '/event-registration',
        query: {'id': id}
        });
      // let route = this.$router.resolve('/link/to/page'); // This also works.
      window.open(route.href, '_blank', "height=800,width=1000");      
    },
    // sendEmail(id){
    
    //   if(confirm("Do you really want to send email to participant?")){
    //     event.sendEmail(id)
    //     .then(res => {
    //       EventBus.$emit('TABLE_UPDATE', true)
    //       var params = {title: 'Success', mode:'success', data:res.message}
    //       EventBus.$emit('OPEN_MODAL_ALERT', params)
    //     }).catch ((err) => {
    //       var params = {title: 'Error', mode:'danger', data:err.response.data.message}
    //       EventBus.$emit('OPEN_MODAL_ALERT', params)
    //     })
    //   }  
    
    // },
    deactivate(id){
       //SET PERMISSION EACH FEATURE
      // let Permission = store.state.user.authenticated.permission
      // if (typeof Permission != 'undefined') {
      //   if(Permission.indexOf('Delete tujuan') !== -1){
          //IF ALLOW
      if(confirm("Do you really want to deactivate?")){
        event.deactivateEvent(id)
        .then(res => {
          EventBus.$emit('TABLE_UPDATE', true)
          var params = {title: 'Success', mode:'success', data:res.message}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
        }).catch ((err) => {
          var params = {title: 'Error', mode:'danger', data:err.response.data.message}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
        })
      }  
      //END ALLOW
      //   }else{
      //     //IF NOT
      //     var params = {title: 'Error', mode:'danger', data:'unautenticated'}
      //     EventBus.$emit('OPEN_MODAL_ALERT', params)
      //   } 
      // }
      //SET END
    },

    reactivate(id){
      //SET PERMISSION EACH FEATURE
      // let Permission = store.state.user.authenticated.permission
      // if (typeof Permission != 'undefined') {
      //   if(Permission.indexOf('Delete tujuan') !== -1){
          //IF ALLOW
      if(confirm("Do you really want to reactivate?")){
        event.reactivateEvent(id)
        .then(res => {
          EventBus.$emit('TABLE_UPDATE', true)
          var params = {title: 'Success', mode:'success', data:res.message}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
        }).catch ((err) => {
          var params = {title: 'Error', mode:'danger', data:err.response.data.message}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
        })
      }
      //END ALLOW
      //   }else{
      //     //IF NOT
      //     var params = {title: 'Error', mode:'danger', data:'unautenticated'}
      //     EventBus.$emit('OPEN_MODAL_ALERT', params)
      //   } 
      // }
      //SET END
    },

    loadData() {
      let current_page = this.search == '' ? this.current_page:1
      var params = {
       
        page: this.current_page,
        per_page: this.per_page,
        search: this.search,
        sortby: this.sortBy,
        sortbydesc: this.sortByDesc ? 'DESC':'ASC',
        is_active: this.is_active,
        id: this.$route.query.id
      }

      event.getEventDataSourceEventOrder(params)
      .then(res => {
          let getData = res.data
          this.items = getData.data
          //this.is_active = res.is_active
          this.meta = {
              total: getData.total,
              current_page: getData.current_page,
              per_page: getData.per_page,
              from: getData.from,
              to: getData.to,
              is_active: res.is_active
          }
      }).catch ((err) => {
        var params = {title: 'Error', mode:'danger', data:err.response.data.message}
        EventBus.$emit('OPEN_MODAL_ALERT', params)
      })
    },

    handlePerPage(val) {
        this.per_page = val 
        this.loadData() 
    },
    
    handlePagination(val) {
        this.current_page = val 
        this.loadData()
    },
    
    handleSearch(val) {
        this.search = val 
        this.current_page = 1 
        this.loadData() 
    },
  
    handleSort(val) {
        this.sortBy = val.sortBy
        this.sortByDesc = val.sortDesc
        this.loadData()
    },
    
    handleIsActive(val) {
        this.is_active = val 
        this.loadData() 
    },

////HANDLE FUNCTION BUTTON ACTION////
   handleShow(val) {
        this.openShow(val) 
    }, 
    handleShowEvent(val) {
        this.openShowEvent(val) 
    }, 
    handleEditEvent(val) {
        this.openEditEvent(val) 
    }, 
    handleShowRegistrationPage(val) {
        this.showRegistrationPage(val) 
    },    
    handlechangeToPublish(val) {
        this.changeToPublish(val) 
    },    
    handleDeactivate(val) {
        this.deactivate(val)       
    },
    handleReactivate(val) {
        this.reactivate(val)       
    },   

  

  }
}
</script>
